export const convertDateToTimeString = (date: Date): string => {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const convertDateToTimeInputString = (date: Date): string => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
};

export const convertDateToDateString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const parseDateInputValue = (date: string): Date => {
  return new Date(`${date}T00:00:00`);
};

export const addDaysToDate = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const getStartOfWeek = (date: Date): Date => {
  const result = new Date(date);
  const day = result.getDay();
  const diff = day === 0 ? -6 : 1 - day;

  result.setHours(0, 0, 0, 0);
  result.setDate(result.getDate() + diff);

  return result;
};

const capitalize = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const formatDateToWeekday = (date: Date, options?: Intl.DateTimeFormatOptions) => {
  const userLocale = navigator.language;
  const formattedDate = date.toLocaleDateString(userLocale, {
    weekday: 'short',
    ...options,
  });

  return capitalize(formattedDate);
};

export const formatDateToDayAndMonth = (date: Date) => {
  const userLocale = navigator.language;
  return date.toLocaleDateString(userLocale, { day: 'numeric', month: 'short' });
};

export const formatDateToWeekRange = (startDate: Date) => {
  const endDate = addDaysToDate(startDate, 6);
  return `${formatDateToDayAndMonth(startDate)} - ${formatDateToDayAndMonth(endDate)}`;
};

export const formatDateToMonthAndYear = (date: Date) => {
  const userLocale = navigator.language;
  const formattedDate = date.toLocaleString(userLocale, { year: 'numeric', month: 'long' });
  return capitalize(formattedDate);
};
